import { render, staticRenderFns } from "./ValidPhoneNumber.vue?vue&type=template&id=120e6581&scoped=true&"
import script from "./ValidPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./ValidPhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./ValidPhoneNumber.vue?vue&type=style&index=0&id=120e6581&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120e6581",
  null
  
)

export default component.exports